import { UserPermission } from 'constants/userPermission';
import { useUserPermissions } from 'app/hooks/useUserPermissions';

export const todoAction = {
  editDateTime: 'editDateTime',
  maintenance: 'maintenance',
  learnAboutInstagramBusiness: 'learnAboutInstagramBusiness',
  installMobileApp: 'installMobileApp',
  connectProfile: 'connectProfile',
  choosePlan: 'choosePlan',
  noAction: 'noAction',
};

export type TodoActionsKeys = keyof typeof todoAction;
export type TodoActionsValues = (typeof todoAction)[TodoActionsKeys];

export function useGetTodoAction(message: string): TodoActionsValues {
  const userPermission = useUserPermissions();

  if (
    (message.toLowerCase().includes('set the date') ||
      message.toLowerCase().includes('set the time') ||
      message.includes('future')) &&
    !message.includes('Missing') &&
    !message.includes('greater')
  ) {
    return userPermission.hasEvery(UserPermission.POST_EDIT_DATE_TIME)
      ? todoAction.editDateTime
      : todoAction.noAction;
  }

  if (message.includes('maintenance')) {
    return todoAction.maintenance;
  }

  if (message.includes('Kontentino mobile app')) {
    return todoAction.installMobileApp;
  }

  if (
    message.includes('has not been associated') ||
    message === 'Your LinkedIn Authorization has expired.' ||
    message.includes('needs to be connected') ||
    message.toLowerCase().includes('login expired')
  ) {
    return userPermission.hasEvery(UserPermission.PAGE_CREATE)
      ? todoAction.connectProfile
      : todoAction.noAction;
  }

  if (message.includes('schedule during a free trial')) {
    return todoAction.choosePlan;
  }

  if (
    message.includes(
      'Your Instagram account type is Creator / Personal. To schedule your posts, change it to Business.',
    )
  ) {
    return todoAction.learnAboutInstagramBusiness;
  }

  return todoAction.noAction;
}

export function getTodoActionBtnLabel(actionable: TodoActionsValues) {
  switch (actionable) {
    case todoAction.editDateTime:
      return 'Change';
    case todoAction.maintenance:
      return 'Edit';
    case todoAction.connectProfile:
      return 'Click to connect';
    case todoAction.choosePlan:
      return 'Choose plan';
    case todoAction.learnAboutInstagramBusiness:
      return 'Learn how';
    default:
      return undefined;
  }
}
